import { each } from "../common/polyfill.js";

async function request(url) {
  let options = {
    method: "GET"
  };
  try {
    var resp = await fetch(url, options);
  } catch (e) {
    throw `Problem connecting: ${e}`;
  }
  if (resp.status < 200 || resp.status > 299) {
    throw `Problem with server response: ${resp.statusText}`;
  }
  try {
    return await resp.json();
  } catch (e) {
    throw `Problem decoding results: ${e}`;
  }
}

function sanitize(text) {
  // If &amp; etc. is in the text, let it pass, but strip any tags
  let sanitizer = document.createElement("div");
  sanitizer.innerHTML = text;
  sanitizer.textContent = sanitizer.innerText;
  return sanitizer.innerHTML;
}

each("[data-feed-url]", el => {
  let feedURL = el.getAttribute("data-feed-url");
  let limit = el.getAttribute("data-limit") || "5";
  limit = parseInt(limit, 10);

  let updateFeed = async () => {
    try {
      var data = await request(feedURL);
    } catch (e) {
      el.innerHTML = `<li class='panel-block'>Could not load weather feed.</li>`;
      return;
    }

    el.innerHTML = "";
    let items = data.items;
    items.sort((a, b) => {
      if (a.date_published === b.date_published) return 0;
      return a.date_published > b.date_published ? -1 : 1;
    });
    items = items.slice(0, limit);
    items.forEach(item => {
      el.insertAdjacentHTML(
        "beforeend",
        `<li>
          <a
            class="has-text-dark panel-block"
            href="${encodeURI(item.url)}"
          >
             ${sanitize(item.title)}
          </a>
        </li>`
      );
    });
  };

  updateFeed();

  let refresh = el.getAttribute("data-refresh");
  if (refresh) {
    window.setTimeout(updateFeed, refresh);
  }
});
